import { Component, OnInit } from '@angular/core';
import { applicationConfig } from '../../applicationConfig';
import { CookieService } from 'ngx-cookie-service';

// Component Decorator
@Component({
    selector: 'footer-comp',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

// Component Class
export class FooterComponent implements OnInit {
    constructor(public _cookieService: CookieService) { 
    }

    ngOnInit() {
        const footerConfig = applicationConfig;
        window.sessionStorage.setItem('overlay', JSON.stringify(footerConfig.overlay));
        if (this._cookieService.get('UserMigrated')) {
            this._cookieService.set('migratedSession', 'true', null, '/', '.prudential.com');
            this._cookieService.delete('UserMigrated', '/', '.prudential.com');
        }
    }
}